module.exports = __webpack_public_path__ + "static/img/ltx.3d13d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ltx.png
// module id = 415
// module chunks = 2